import React, { Fragment } from 'react';
import { styles } from '4all-ui/styles';
import PropTypes from 'prop-types';
import Formats from '../../../../../../helpers/formats';
import Box from '../Box';
import * as styled from './style';

const getFormattedCurrency = value => Formats.formatCurrency(value.toString());

const renderProductList = items => (
  <Fragment>
    <styled.ProductListContainer>
      {items.map(item => (
        <styled.ProductListItemContainer key={`${item.quantity}-${item.id}`}>
          <styled.ProductListItem>
            <styled.LeftColumn>
              <styled.Quantity>{`${item.quantity}x`}</styled.Quantity>
              <styled.Name>{item.title}</styled.Name>
            </styled.LeftColumn>
            <styled.MiddleColumn>
              <styled.Price isProduct>
                {Formats.formatCurrency(item.itemPrice.toString())}
              </styled.Price>
            </styled.MiddleColumn>
            <styled.RightColumn>
              <styled.TotalPrice>
                {Formats.formatCurrency((item.itemPrice * item.quantity).toString())}
              </styled.TotalPrice>
            </styled.RightColumn>
          </styled.ProductListItem>

          <styled.vl>
            {item.comboItems &&
              item.comboItems.map(comboItem => (
                <Fragment key={`comboItem-${comboItem.id}-${comboItem.id}`}>
                  <styled.ProductListItem>
                    <styled.LeftColumn>
                      <styled.SubItem paddingLeft="6px">{`${comboItem.title}`}</styled.SubItem>
                    </styled.LeftColumn>
                    <styled.MiddleColumn>
                      <styled.Price>
                        {Formats.formatCurrency(comboItem.itemPrice.toString())}
                      </styled.Price>
                    </styled.MiddleColumn>
                    <styled.RightColumn />
                  </styled.ProductListItem>
                  {comboItem.subItems.map(subItem => {
                    const quantity = Formats.formatQuantity(subItem.quantity) || '';
                    return (
                      <styled.ProductListItem
                        isVariation
                        key={`subitem-${subItem.id}-${subItem.id}`}
                      >
                        <styled.LeftColumn>
                          <styled.SubItem paddingLeft="12px">{`+${quantity} ${
                            subItem.title
                          }`}</styled.SubItem>
                        </styled.LeftColumn>
                        <styled.MiddleColumn>
                          <styled.Price price={subItem.itemPrice} isVariation>
                            {Formats.formatCurrency(subItem.itemPrice.toString())}
                          </styled.Price>
                        </styled.MiddleColumn>
                        <styled.RightColumn>
                          {subItem.itemPrice > 0 && (
                            <styled.TotalPrice>
                              {getFormattedCurrency(
                                ((subItem.itemPrice * subItem.quantity) * item.quantity).toString()
                              )}
                            </styled.TotalPrice>
                          )}
                        </styled.RightColumn>
                      </styled.ProductListItem>
                    );
                  })}
                </Fragment>
              ))}
          </styled.vl>
          <styled.vl>
            {item.subItems &&
              item.subItems.map(subItem => {
                const quantity = Formats.formatQuantity(subItem.quantity) || '';
                return (
                  <styled.ProductListItem isVariation key={`subitem-${item.id}-${subItem.id}`}>
                    <styled.LeftColumn>
                      <styled.SubItem paddingLeft="6px">{`+${quantity} ${
                        subItem.title
                      }`}</styled.SubItem>
                    </styled.LeftColumn>
                    <styled.MiddleColumn>
                      <styled.SubItem>
                        <styled.Price price={subItem.itemPrice}>
                          {Formats.formatCurrency(subItem.itemPrice.toString())}
                        </styled.Price>
                      </styled.SubItem>
                    </styled.MiddleColumn>
                    <styled.RightColumn>
                      {subItem.itemPrice > 0 && (
                        <styled.TotalPrice>
                          {getFormattedCurrency(subItem.itemPrice.toString())}
                        </styled.TotalPrice>
                      )}
                    </styled.RightColumn>
                  </styled.ProductListItem>
                );
              })}
          </styled.vl>

          {item.observation && (
            <styled.ProductListItem>
              <styled.LeftColumn>
                <styled.Comment>{`Observações: ${item.observation}`}</styled.Comment>
              </styled.LeftColumn>
              <styled.MiddleColumn />
              <styled.RightColumn />
            </styled.ProductListItem>
          )}
        </styled.ProductListItemContainer>
      ))}
    </styled.ProductListContainer>
  </Fragment>
);

const renderSubtotal = order => (
  <styled.SubtotalContainer>
    <styled.SubtotalItem>
      <styled.MiddleColumn>
        <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Subtotal</styled.Title>
      </styled.MiddleColumn>
      <styled.RightColumn>
        <styled.Price isSubtotal>{getFormattedCurrency(order.productTotal)}</styled.Price>
      </styled.RightColumn>
    </styled.SubtotalItem>

    <styled.SubtotalItem>
      <styled.MiddleColumn>
        <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Frete</styled.Title>
      </styled.MiddleColumn>
      <styled.RightColumn>
        <styled.Price isSubtotal>{getFormattedCurrency(order.deliveryFee)}</styled.Price>
      </styled.RightColumn>
    </styled.SubtotalItem>

    {order.friendlyCode ? (
      <styled.SubtotalItem style={{ lineHeight: '20px' }}>
        <styled.MiddleColumn>
          <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Descontos:</styled.Title>
          <styled.Title color={styles.colors.GRAY_MEDIUM_3}>{order.friendlyCode}</styled.Title>
        </styled.MiddleColumn>
        <styled.RightColumn>
          <styled.Price style={{ opacity: 0 }}> - </styled.Price>
          <styled.Price isSubtotal isDiscount>
            {' '}
            - {getFormattedCurrency(order.discount)}
          </styled.Price>
        </styled.RightColumn>
      </styled.SubtotalItem>
    ) : (
      <styled.SubtotalItem>
        <styled.MiddleColumn>
          <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Descontos</styled.Title>
        </styled.MiddleColumn>
        <styled.RightColumn>
          <styled.Price isSubtotal isDiscount>
            {' '}
            - {getFormattedCurrency(order.discount)}
          </styled.Price>
        </styled.RightColumn>
      </styled.SubtotalItem>
    )}

    <styled.SubtotalItem>
      <styled.MiddleColumn>
        <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Cashback</styled.Title>
      </styled.MiddleColumn>
      <styled.RightColumn>
        <styled.Price isSubtotal isDiscount>
          {' '}
          - {getFormattedCurrency(order.cashback)}
        </styled.Price>
      </styled.RightColumn>
    </styled.SubtotalItem>
  </styled.SubtotalContainer>
);

const renderTotal = order => (
  <styled.TotalContainer>
    <styled.TotalItem>
      <styled.MiddleColumn>
        <styled.Price isTotal>Total do Pedido</styled.Price>
      </styled.MiddleColumn>
      <styled.RightColumn>
        <styled.TotalPrice isSubtotal big>
          {getFormattedCurrency(order.total)}
        </styled.TotalPrice>
      </styled.RightColumn>
    </styled.TotalItem>
  </styled.TotalContainer>
);

const renderHeaderContent = () => (
  <styled.HeaderContent>
    <styled.MiddleColumn>
      <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Preço Unitário</styled.Title>
    </styled.MiddleColumn>
    <styled.RightColumn>
      <styled.Title color={styles.colors.GRAY_MEDIUM_3}>Subtotal</styled.Title>
    </styled.RightColumn>
  </styled.HeaderContent>
);

const renderContent = order => (
  <Fragment>
    {renderProductList(order.orderItems)}
    {renderSubtotal(order)}
    {renderTotal(order)}
  </Fragment>
);

const BoxProducts = ({ data }) => (
  <Box
    customStyles={{ marginTop: 20 }}
    contentStyles={{ padding: '15px 20px' }}
    headerContent={renderHeaderContent()}
    title="Produtos"
    size={8}
    content={renderContent(data)}
  />
);

BoxProducts.propTypes = {
  data: PropTypes.object,
};

BoxProducts.defaultProps = {
  data: {},
};

export default BoxProducts;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/OrderDetails/Components/BoxProduct/index.js